module.exports = __webpack_public_path__ + "img/google_wallet.606fbce7.svg";